<template>
    <Toast :baseZIndex="9999" />
    <div class="p-grid">
        <div class="p-col-12">
            <div class="p-d-flex p-ai-center p-jc-between p-flex-column p-flex-lg-row p-mb-1">
                <h5>Admin Component Charges</h5>
                <div>
                    <Button label="Dashboard" class="p-button-sm p-mr-2" @click="goToDashboard" icon="pi pi-th-large" />
                    <Button label="Previous" class="p-button-sm p-mr-1" @click="goToPrevious"
                        icon="pi pi-chevron-left" />
                    <Button label="Next" icon="pi pi-chevron-right" @click="goToNext" class="p-button-sm"
                        iconPos="right" />
                </div>
            </div>
            <div class="card">
                <div style="position: relative" v-if="!showLoader">
                    <div class="p-py-4 p-px-3">
                        <div class="p-fluid p-formgrid p-grid">
                            <DataTable :value="documents" :lazy="true" :paginator="true" :rows="30"
                                :totalRecords="totalRecords" :loading="loading" @page="onPage($event)"
                                class="p-datatable-users" data-key="bd1" :rowHover="true"
                                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                                currentPageReportTemplate="Showing {first} to {last} of {totalRecords}">
                                <Toolbar>
                                    <template v-slot:left>
                                        <h6>Admin Name : {{ this.localAdminName ? this.localAdminName : '-' }} </h6>
                                    </template>
                                    <template v-slot:right>
                                        <Button label="Add Component Charges" icon="pi pi-plus"
                                            @click="onAddDocument" />

                                        <!-- <Toast />
                                        <FileUpload mode="basic" name="demo[]" url="./upload.php" accept="*" :maxFileSize="1000000" @upload="onUpload" chooseLabel="Add Client Document"/> -->
                                    </template>
                                </Toolbar>
                                <template #empty> No data found. </template>
                                <template #loading> Loading data. Please wait... </template>
                                <Column field="id" header="Sr." headerStyle="width: 5%">
                                    <template #body="{ index }">
                                        <div>{{ genrateSrNo(index) }}</div>
                                    </template>
                                </Column>
                                <Column header="Component" field="hf2" class="p-text-capitalize"
                                    headerStyle="width: 45%">
                                </Column>
                                <Column header="GEL Charges" field="hf21" class="p-text-capitalize" headerStyle="width: 35%">\
                                    <template #body="{ data }">
                                        <div class="">{{ data.hf21 ? data.hf21 : '-' }}</div>
                                    </template>
                                </Column>
                                <Column header="Charges" field="hf22" class="p-text-capitalize"
                                    headerStyle="width: 35%">
                                </Column>
                                <Column header="Action" headerStyle="width: 10%">
                                    <template #body="{ data }">
                                        <Button icon="pi pi-pencil" class="p-button-rounded p-button-success p-mr-2"
                                            @click="onEditDocument(data)" />
                                    </template>
                                </Column>
                            </DataTable>
                        </div>
                    </div>
                </div>
                <div v-if="showLoader" style="height: 390px; position: relative">
                    <div class="custom-modal-spinner-loader">
                        <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Add/Edit Document Dialog starts here -->
    <Dialog v-model:visible="isDialogOpen" :style="{ width: '800px' }" :modal="true" class="p-fluid"
        :header="dialogHeader">
        <div style="position: relative">
            <div class="p-pt-2 p-px-3">
                <div class="p-fluid p-formgrid p-grid">
                    <div class="p-field p-col-12 p-md-12">
                        <label for="component">
                            Select Component
                            <span class="p-invalid p-error">*</span>
                        </label>
                        <Dropdown id="component" v-model="component" :disabled="editDocumentFlag" :options="componentList" optionLabel="label"
                            required="true" :object="true" placeholder="Select Component" emptyMessage="No Records"
                            appendTo="body" />
                        <small class="p-invalid p-error" v-if="v$.component.$error">{{
                            v$.component.$errors[0].$message
                            }}</small>
                    </div>
                    <!-- <div class="p-field p-col-12 p-md-12">
                        <label for="charge-type">
                            Charge For
                            <span class="p-invalid p-error">*</span>
                        </label>
                        <Dropdown id="charge-type" v-model="charge_type" :options="chargesTypes" optionLabel="label"
                            required="true" :class="{ 'p-invalid': isSubmitted && !charge_type }"
                            placeholder="Select Document" emptyMessage="No Records" appendTo="body" />
                        <small class="p-invalid p-error" v-if="v$.chargesTypes.$error">{{
                            v$.chargesTypes.$errors[0].$message
                        }}</small>
                    </div> -->
                    <div class="p-field p-col-12 p-md-12">
                        <label for="charges">
                            GEL Charges
                        </label>
                        <InputText id="gelcharges" v-model="gelcharges" required="true"
                        maxlength="70"  placeholder="Enter GEL Charges" />
                    </div>
                    <div class="p-field p-col-12 p-md-12">
                        <label for="charges">
                            Charges
                            <span class="p-invalid p-error">*</span>
                        </label>
                        <InputText id="charges" inputmode="numeric" v-model="charges" required="true" maxlength="5" @keypress="onlyNumber" placeholder="Enter Charges" />
                        <small class="p-invalid p-error" v-if="v$.charges.$error">{{
                            v$.charges.$errors[0].$message
                            }}</small>
                    </div>
                </div>
            </div>
        </div>
        <template #footer>
            <Button label="Submit" :icon="!showLoader ? 'pi pi-check' : 'pi pi-spin pi-spinner indigo-color'"
                class="p-button-text p-ml-auto" @click="addDocument" style="width: 90px;"
                :disabled="showLoader"></Button>
        </template>
    </Dialog>
    <!-- Add/Edit Document Dialog ends here -->
</template>

<script>
import ApiService from '../../service/ApiService';
import useValidate from '@vuelidate/core';
import { useRoute } from 'vue-router';
import router from '@/router';
import { required, helpers } from '@vuelidate/validators';
// import moment from "moment";

export default {
    data() {
        return {
            documents: [],
            v$: useValidate(),
            isDialogOpen: false,
            isSubmitted: false,
            documentType: "",
            document: null,
            showLoader: false,
            expandedRows: [],
            loading: false,
            page_no: 0,
            totalRecords: 0,
            chargesTypes: [],
            componentList: [],
            isEditDocument: false,
            // fromDate: null,
            // toDate: null,
            todaysDate: new Date(),
            remark: "",
            documentError: "",
            dialogHeader: "",
            validation: {},
            documentId: '',
            doc_file_name: "",
            documentName: '',
            localAdminName: '',
            charges: '',
            charge_type: '',
            component: '',
            gelcharges:'',
            editDocumentFlag: false,
        };
    },
    validations() {
        this.validation = {
            charges: { required: helpers.withMessage('Please enter charges', required) },
            component: { required: helpers.withMessage('Please Select component', required) },
        };
        return this.validation;
    },
    ApiService: null,
    interval: null,
    created() {
        this.ApiService = new ApiService();
    },
    mounted() {
        const route = useRoute();
        this.routeParam = route.params.adminSubId;
        this.localAdminName = localStorage.localAdminName;
        this.loading = true;
        this.chargesTypes = [
            { value: 1, label: "GEL" },
            { value: 2, label: "End User" },
        ];

        // this.getAdminDocumentDetails({ clientid: this.routeParam, page_no: this.page });
        this.getComponentChargesList({ clientid: this.routeParam, page_no: this.page });
        this.getAllComponents();
    },
    methods: {
        getAllComponents() {
            this.loading = true;
            this.ApiService.getAllComponents().then((data) => {
                if (data.status == 200) {
                    this.componentList = data.data;
                } else {
                    this.componentList = '';
                }
                this.loading = false;
            });
        },
        
        onAddDocument() {
            this.v$.$reset();
            this.doc_file_name = "";
            /** Open popup of add document gode goes here */
            this.dialogHeader = 'Add Component Charges';
            this.isDialogOpen = true;
            this.component = '';
            // this.fromDate = null;
            // this.toDate = null;
            this.charges = null;
            this.editDocumentFlag = false;
            this.gelcharges = null;
        },
        onEditDocument(data) {
            this.dialogHeader = "Edit Component Charge";
            this.isDialogOpen = true;
            this.component = this.componentList.find(item => item.label == data.hf2)
            this.charges = data.hf22;
            this.editDocumentFlag = true;
            this.gelcharges = data.hf21;
        },
        async getComponentChargesList(params) {
            try {
                const result = await this.ApiService.getComponentChargesList({ ...params })
                this.loading = false;
                if (!result.success) {
                    return this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Something went wrong.', life: 3000 });
                }

                this.documents = result.data.result;
                this.totalRecords = result.data.count;
            } catch (error) {
                this.$toast.add({ severity: 'error', summary: 'Error', detail: 'Something went wrong.', life: 3000 });

            }
        },
        addDocument() {
            this.isSubmitted = true;
            this.v$.$validate();
            let formData = new FormData();

            formData.append("maa1", this.routeParam);
            if (this.editDocumentFlag == true) {
                formData.append("hf1", this.component.value);
            }
            formData.append("hf2", this.component.label);
            formData.append("hf22", this.charges);
            formData.append("hf21", this.gelcharges);

            if (!this.v$.$error) {
                this.showLoader = true;
                this.ApiService.updateComponentCharges(formData).then((items) => {
                    if (items.status == 200) {
                        this.showLoader = false;
                        var successMsg = items.message;
                        this.$toast.add({ severity: 'success', summary: 'Successful', detail: successMsg, life: 3000 });
                        this.isDialogOpen = false;
                        this.getComponentChargesList({ clientid: this.routeParam, page_no: this.page });
                        this.documentId = '';
                        this.v$.$reset();
                    } else {
                        this.showLoader = false;
                        var errorMsg = items.message;
                        this.$toast.add({ severity: 'error', summary: 'Error', detail: errorMsg, life: 3000 });
                    }
                });
            }
        },
        
        onlyNumber(event) {
            if (/[0-9]/.test(event.key)) {
                return;
            }
            if (event.key === "." && !event.target.value.includes(".")) {
                return;
            }
            event.preventDefault();
        },
        deleteDocument() {
            /** Delete Document code goes here */
        },
        onPage(event) {
            this.loading = true;
            this.page_no = event.page;
            this.getComponentChargesList({ clientid: this.routeParam, page_no: event.page });
        },
        goToDashboard() {
            router.push({
                name: "admindashboard",
                params: { adminId: this.routeParam },
            });
        },
        goToPrevious() {
            router.push({
                name: "modulesetting",
                params: { adminSubId: this.routeParam },
            });
        },
        goToNext() {
            router.push({
                name: "adminrole",
                params: { adminSubId: this.routeParam },
            });
        }
    }
};
</script>

<style scoped></style>
